import React, { useContext, useEffect, useState } from "react";
import SD_Pratyaksha_Seva_Inner_Component_One from "../../../Components/body/sd-pratyaksha-seva/sd-pratyaksha-seva-inner-components/sd-pratyaksha-seva-inner-component-one";
import Sd_gallery_semi_view from "../../../Components/sd-common-components/sd-gallery-semi-view";
import SD_Pratyaksha_Seva_One from "../../../Components/body/sd-pratyaksha-seva/sd-pratyaksha-seva-component-one";
import PratyakshaSevaService from "../../../services/sd-pratyakshaseva.service";
import { SD_Context } from "../../../context/sd-context";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sd_faqs_semi_view from "../../../Components/sd-common-components/sd-faqs-semi-view";

import Sd_loading from "../../../Components/sd-common-components/sd-loading";
import { Helmet } from "react-helmet";
import SD_Pratyaksha_Seva_Inner_Component_Two from "../../../Components/body/sd-pratyaksha-seva/sd-pratyaksha-seva-inner-components/sd-pratyaksha-seva-inner-component-two";
import { withRouter } from "react-router-dom";

const Sd_sevas_and_darshanam_pratyakshaseva_common = ({ match }) => {
  //-------------------------------------------------------------states-----------------------------------------------------------//
  const { pratyakshaSevaData, templeID, setPratyakshaSevaData } =
    useContext(SD_Context);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  //-------------------------------------------------------------states-----------------------------------------------------------//

  //-------------------------------------------------------------useeffect-----------------------------------------------------------//
  useEffect(() => {
    if (pratyakshaSevaData.length !== 0) {
      setLoading(true);
      let datas = pratyakshaSevaData.find(
        (item) =>
          item?.name
            ?.replace?.(/\s/g, "")
            ?.replace?.(/[{()}]/g, "")
            .toLowerCase() === match.params.id.replaceAll("-", "")
      );
      if (datas) {
        setData(datas);
        setLoading(false);
      }
    } else {
      getData();
    }
  }, [match]);
  //-------------------------------------------------------------useeffect-----------------------------------------------------------//

  //-------------------------------------------------------------functions-----------------------------------------------------------//
  const getData = async () => {
    setLoading(true);
    try {
      let data = await PratyakshaSevaService.getAllOnline(templeID);
      if (data) {
        setPratyakshaSevaData(
          data.filter(
            (item) => item.sevaType === "pratyakshaSeva" && item.onlineEnabled
          )
        );
        let datas = data.find(
          (item) =>
            item?.name
              ?.replace?.(/\s/g, "")
              ?.replace?.(/[{()}]/g, "")
              .toLowerCase() === match.params.id.replaceAll("-", "")
        );
        setData(datas);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };
  //-------------------------------------------------------------functions-----------------------------------------------------------//
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {`${data?.name} Srisailam Online Booking | Prathyaksha Seva | Srisailam
          Online`}
        </title>
        <meta
          name="description"
          content={`Participate in ${data?.name} by purchasing Paroksha Seva tickets Online.`}
        />
        <meta
          name="keywords"
          content={`${data?.name}, Srisailam Online Booking, Prathyaksha Seva, Srisailam Online`}
        />
      </Helmet>
      {loading ? (
        <Sd_loading />
      ) : (
        <div className="w-100">
          <SD_Pratyaksha_Seva_One from={`p-${data?.name}`} data={data} />
          <SD_Pratyaksha_Seva_Inner_Component_One data={data} />{" "}
          <SD_Pratyaksha_Seva_Inner_Component_Two data={data} />
          <Sd_faqs_semi_view from="udhayaasthamana_seva" />
          {/* <SD_Paroksha_Seva_Four /> */}
          <Sd_gallery_semi_view />
        </div>
      )}
    </>
  );
};
export default withRouter(Sd_sevas_and_darshanam_pratyakshaseva_common);
